import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { Grid } from "@material-ui/core";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";

const RenderTaxationFields = ({ rulesTaxation, type, visualizationOnly }) => {
  const [lastTaxation, setLastTaxation] = useState(null);

  const {
    productError,
    productIcmsModality,
    setProductIcmsModality,
    productIcmsValueBc,
    setProductIcmsValueBc,
    productIcmsAliquot,
    setProductIcmsAliquot,
    productIcmsValue,
    setProductIcmsValue,
    productIcmsStModality,
    setProductIcmsStModality,
    productIcmsStPercentAdd,
    setProductIcmsStPercentAdd,
    productIcmsStPercentReductBc,
    setProductIcmsStPercentReductBc,
    productIcmsStValueBc,
    setProductIcmsStValueBc,
    productIcmsStAliquot,
    setProductIcmsStAliquot,
    productIcmsStValue,
    setProductIcmsStValue,
    productIcmsAliquotCredit,
    setProductIcmsAliquotCredit,
    productIcmsCreditAprove,
    setProductIcmsCreditAprove,
    productIcmsStValueBcRet,
    setProductIcmsStValueBcRet,
    productIcmsAliquotSupCons,
    setProductIcmsAliquotSupCons,
    productIcmsOwnSubValue,
    setProductIcmsOwnSubValue,
    productIcmsStValueRet,
    setProductIcmsStValueRet,
    productIcmsStBcPovertyRet,
    setProductIcmsStBcPovertyRet,
    productIcmsStAliqPovertyRet,
    setProductIcmsStAliqPovertyRet,
    productIcmsStValuePovertyRet,
    setProductIcmsStValuePovertyRet,
    productIcmsPercentReduct,
    setProductIcmsPercentReduct,
    productIcmsListModality,
    productIcmsStListModality,
    productIcmsValueDes,
    setProductIcmsValueDes,
    productImcsMotivoDes,
    setProductImcsMotivoDes,
    productImcsListReasonExemption,
    productIcmsAliquotInterstate,
    setProductIcmsAliquotInterstate,
    productIcmsAliquotInternal,
    setProductIcmsAliquotInternal,
    productDataCfop,
    productIcmsCbenef,
    setProductIcmsCbenef,
    productIcmsAliquotPoverty,
    setProductIcmsAliquotPoverty,
    productIcmsBcPoverty,
    setProductIcmsBcPoverty,
    productIcmsValuePoverty,
    setProductIcmsValuePoverty,
    productIcmsStAliquotPoverty,
    setProductIcmsStAliquotPoverty,
    productIcmsStBcPoverty,
    setProductIcmsStBcPoverty,
    productIcmsStValuePoverty,
    setProductIcmsStValuePoverty,
  } = useContext(ParametrosProdutoContext);

  const validICMSUFDest = useMemo(
    () =>
      [6, 2].includes(parseInt(productDataCfop?.cfop?.toString().charAt(0))),
    [productDataCfop?.cfop]
  );

  const checkValueDes = useMemo(() => {
    return parseFloat((productIcmsValueDes || "0").replace(",", ".")) > 0;
  }, [productIcmsValueDes]);

  const modalidadeBcIcms = useCallback(() => {
    return (
      <Grid item lg={12} sm={12}>
        <Select
          key="modalidadeBcIcms"
          optionsList={productIcmsListModality}
          descriptionField="label"
          label="Modalidade de determinação da BC do ICMS"
          value={productIcmsModality}
          setValue={setProductIcmsModality}
          error={!!productError.productIcmsModality}
          helperText={productError.productIcmsModality || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsModality,
    productIcmsListModality,
    productIcmsModality,
    setProductIcmsModality,
    visualizationOnly,
  ]);

  const bcIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcIcms"
          value={productIcmsValueBc}
          setValue={setProductIcmsValueBc}
          size="small"
          label="BC do ICMS R$"
          mask="decimal"
          error={!!productError.productIcmsValueBc}
          helperText={productError.productIcmsValueBc || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsValueBc,
    productIcmsValueBc,
    setProductIcmsValueBc,
    visualizationOnly,
  ]);

  const reducaoBcIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="reducaoBcIcms"
          value={productIcmsPercentReduct}
          setValue={setProductIcmsPercentReduct}
          size="small"
          label="% Redução da BC ICMS"
          mask="decimal"
          decimals={4}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsPercentReduct,
    setProductIcmsPercentReduct,
    visualizationOnly,
  ]);

  const aliquotaIcms = useCallback(() => {
    return !validICMSUFDest ? (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaIcms"
          value={productIcmsAliquot}
          setValue={setProductIcmsAliquot}
          size="small"
          label="Alíquota do ICMS"
          mask="decimal"
          error={!!productError.productIcmsAliquot}
          helperText={productError.productIcmsAliquot || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    ) : (
      <></>
    );
  }, [
    productError.productIcmsAliquot,
    productIcmsAliquot,
    setProductIcmsAliquot,
    validICMSUFDest,
    visualizationOnly,
  ]);

  const valorIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorIcms"
          value={productIcmsValue}
          setValue={setProductIcmsValue}
          error={!!productError.productIcmsValue}
          helperText={productError.productIcmsValue || ""}
          size="small"
          label="Valor do ICMS R$"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsValue,
    productIcmsValue,
    setProductIcmsValue,
    visualizationOnly,
  ]);

  const icmsDesonerado = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="icmsDesonerado"
          value={productIcmsValueDes}
          setValue={setProductIcmsValueDes}
          size="small"
          label="Valor ICMS Desonerado"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [productIcmsValueDes, setProductIcmsValueDes, visualizationOnly]);

  const motivoDesoneracao = useCallback(() => {
    return checkValueDes > 0 ? (
      <Grid item lg={6} sm={12}>
        <Select
          key="motivoDesoneracao"
          descriptionField="label"
          optionsList={productImcsListReasonExemption}
          value={productImcsMotivoDes}
          setValue={setProductImcsMotivoDes}
          size="small"
          label="Motivo Desoneração"
          disabled={visualizationOnly}
          error={!!productError.productImcsListReasonExemption}
          helperText={productError.productImcsListReasonExemption || ""}
        />
      </Grid>
    ) : (
      <></>
    );
  }, [
    productImcsMotivoDes,
    setProductImcsMotivoDes,
    visualizationOnly,
    productImcsListReasonExemption,
    checkValueDes,
    productError.productImcsListReasonExemption,
  ]);

  const modalidadeBcIcmsSt = useCallback(() => {
    return (
      <Grid item lg={12} sm={12}>
        <Select
          key="modalidadeBcIcmsSt"
          optionsList={productIcmsStListModality}
          descriptionField="label"
          label="Modalidade de determinação da BC do ICMS ST"
          value={productIcmsStModality}
          setValue={setProductIcmsStModality}
          error={!!productError.productIcmsStModality}
          helperText={productError.productIcmsStModality || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStModality,
    productIcmsStListModality,
    productIcmsStModality,
    setProductIcmsStModality,
    visualizationOnly,
  ]);

  const mvaBcIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="mvaBcIcmsSt"
          value={productIcmsStPercentAdd}
          setValue={setProductIcmsStPercentAdd}
          size="small"
          label="% Margem de Valor adic ST"
          mask="decimal"
          error={!!productError.productIcmsStPercentAdd}
          helperText={productError.productIcmsStPercentAdd || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStPercentAdd,
    productIcmsStPercentAdd,
    setProductIcmsStPercentAdd,
    visualizationOnly,
  ]);

  const reducaoBcIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="reducaoBcIcmsSt"
          value={productIcmsStPercentReductBc}
          setValue={setProductIcmsStPercentReductBc}
          size="small"
          label="% Redução da BC ICMS ST"
          mask="decimal"
          error={!!productError.productIcmsStPercentReductBc}
          helperText={productError.productIcmsStPercentReductBc || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStPercentReductBc,
    productIcmsStPercentReductBc,
    setProductIcmsStPercentReductBc,
    visualizationOnly,
  ]);

  const bcIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcIcmsSt"
          value={productIcmsStValueBc}
          setValue={setProductIcmsStValueBc}
          size="small"
          label="Base de Cálculo ICMS ST R$"
          mask="decimal"
          error={!!productError.productIcmsStValueBc}
          helperText={productError.productIcmsStValueBc || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStValueBc,
    productIcmsStValueBc,
    setProductIcmsStValueBc,
    visualizationOnly,
  ]);

  const aliquotaIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaIcmsSt"
          value={productIcmsStAliquot}
          setValue={setProductIcmsStAliquot}
          size="small"
          label="Alíquota ICMS ST"
          mask="decimal"
          error={!!productError.productIcmsStAliquot}
          helperText={productError.productIcmsStAliquot || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStAliquot,
    productIcmsStAliquot,
    setProductIcmsStAliquot,
    visualizationOnly,
  ]);

  const valorIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorIcmsSt"
          value={productIcmsStValue}
          setValue={setProductIcmsStValue}
          size="small"
          label="Valor ICMS ST R$"
          mask="decimal"
          error={!!productError.productIcmsStValue}
          helperText={productError.productIcmsStValue || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStValue,
    productIcmsStValue,
    setProductIcmsStValue,
    visualizationOnly,
  ]);

  const aliquotaCredIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaCredIcms"
          value={productIcmsAliquotCredit}
          setValue={setProductIcmsAliquotCredit}
          size="small"
          label="Aliq. aplicável de cálculo do Crédito: "
          mask="decimal"
          error={!!productError.productIcmsAliquotCredit}
          helperText={productError.productIcmsAliquotCredit || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsAliquotCredit,
    productIcmsAliquotCredit,
    setProductIcmsAliquotCredit,
    visualizationOnly,
  ]);

  const credAproveitadoIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="credAproveitadoIcms"
          value={productIcmsCreditAprove}
          setValue={setProductIcmsCreditAprove}
          size="small"
          label="Crédito do ICMS que pode ser aproveitado R$"
          mask="decimal"
          error={!!productError.productIcmsCreditAprove}
          helperText={productError.productIcmsCreditAprove || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsCreditAprove,
    productIcmsCreditAprove,
    setProductIcmsCreditAprove,
    visualizationOnly,
  ]);

  const bcRetidoIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcRetidoIcmsSt"
          value={productIcmsStValueBcRet}
          setValue={setProductIcmsStValueBcRet}
          size="small"
          label="Base de Cálculo do ICMS ST Retido R$:"
          mask="decimal"
          error={!!productError.productIcmsStValueBcRet}
          helperText={productError.productIcmsStValueBcRet || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStValueBcRet,
    productIcmsStValueBcRet,
    setProductIcmsStValueBcRet,
    visualizationOnly,
  ]);

  const valorRetidoIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorRetidoIcmsSt"
          value={productIcmsStValueRet}
          setValue={setProductIcmsStValueRet}
          size="small"
          label="Valor ICMS ST Retido R$:"
          mask="decimal"
          error={!!productError.productIcmsStValueRet}
          helperText={productError.productIcmsStValueRet || ""}
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productError.productIcmsStValueRet,
    productIcmsStValueRet,
    setProductIcmsStValueRet,
    visualizationOnly,
  ]);

  const bcFcpRetidoIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcFcpRetidoIcmsSt"
          value={productIcmsStBcPovertyRet}
          setValue={setProductIcmsStBcPovertyRet}
          size="small"
          label="Bc Fundo Comb Pobreza ST Retido"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsStBcPovertyRet,
    setProductIcmsStBcPovertyRet,
    visualizationOnly,
  ]);

  const aliquotaFcpRetidoIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaFcpRetidoIcmsSt"
          value={productIcmsStAliqPovertyRet}
          setValue={setProductIcmsStAliqPovertyRet}
          size="small"
          label="Aliq. Fundo Comb Pobreza ST Retido"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsStAliqPovertyRet,
    setProductIcmsStAliqPovertyRet,
    visualizationOnly,
  ]);

  const valorFcpRetidoIcmsSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorFcpRetidoIcmsSt"
          value={productIcmsStValuePovertyRet}
          setValue={setProductIcmsStValuePovertyRet}
          size="small"
          label="Valor Fundo Comb Pobreza ST Retido"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsStValuePovertyRet,
    setProductIcmsStValuePovertyRet,
    visualizationOnly,
  ]);

  const aliquotaConsumidorIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaConsumidorIcms"
          value={productIcmsAliquotSupCons}
          setValue={setProductIcmsAliquotSupCons}
          size="small"
          label="Aliq. Suportada Pelo Consumidor"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsAliquotSupCons,
    setProductIcmsAliquotSupCons,
    visualizationOnly,
  ]);

  const valorProprioIcms = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorProprioIcms"
          value={productIcmsOwnSubValue}
          setValue={setProductIcmsOwnSubValue}
          size="small"
          label="Valor do ICMS Próprio do Substituto"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [productIcmsOwnSubValue, setProductIcmsOwnSubValue, visualizationOnly]);

  const aliquotaIcmsInterestadual = useCallback(() => {
    return validICMSUFDest ? (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaIcmsInterestadual"
          value={productIcmsAliquotInterstate}
          setValue={setProductIcmsAliquotInterstate}
          size="small"
          label="Aliq. ICMS Interestadual"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    ) : (
      <></>
    );
  }, [
    productIcmsAliquotInterstate,
    setProductIcmsAliquotInterstate,
    validICMSUFDest,
    visualizationOnly,
  ]);

  const aliquotaIcmsInternaDest = useCallback(() => {
    return validICMSUFDest ? (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaIcmsInternaDest"
          value={productIcmsAliquotInternal}
          setValue={setProductIcmsAliquotInternal}
          size="small"
          label="Aliq. ICMS Interna Dest."
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    ) : (
      <></>
    );
  }, [
    productIcmsAliquotInternal,
    setProductIcmsAliquotInternal,
    validICMSUFDest,
    visualizationOnly,
  ]);

  const aliquotaFundoCombPobreza = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaFundoCombPobreza"
          value={productIcmsAliquotPoverty}
          setValue={setProductIcmsAliquotPoverty}
          size="small"
          label="Aliq. Fundo Comb. Pobreza"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsAliquotPoverty,
    setProductIcmsAliquotPoverty,
    visualizationOnly,
  ]);

  const bcFundoCombPobreza = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcFundoCombPobreza"
          value={productIcmsBcPoverty}
          setValue={setProductIcmsBcPoverty}
          size="small"
          label="Base de Cálculo Fundo Comb.Pobreza"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [productIcmsBcPoverty, setProductIcmsBcPoverty, visualizationOnly]);

  const valorIcmsFundoCombPobreza = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorIcmsFundoCombPobreza"
          value={productIcmsValuePoverty}
          setValue={setProductIcmsValuePoverty}
          size="small"
          label="Valor ICMS Fundo Comb. Pobreza"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [productIcmsValuePoverty, setProductIcmsValuePoverty, visualizationOnly]);

  const cBenef = useCallback(() => {
    return (
      <Grid item lg={8} sm={8}>
        <TextField
          key="cBenef"
          value={productIcmsCbenef}
          maxLength={30}
          setValue={setProductIcmsCbenef}
          size="small"
          label="cBenef"
        />
      </Grid>
    );
  }, [productIcmsCbenef, setProductIcmsCbenef]);

  const bcFundoCombPobrezaSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="bcFundoCombPobrezaSt"
          value={productIcmsStBcPoverty}
          setValue={setProductIcmsStBcPoverty}
          size="small"
          label="Base de Cálculo Fundo Comb. Pobreza ST"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [productIcmsStBcPoverty, setProductIcmsStBcPoverty, visualizationOnly]);

  const aliquotaFundoCombPobrezaSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="aliquotaFundoCombPobrezaSt"
          value={productIcmsStAliquotPoverty}
          setValue={setProductIcmsStAliquotPoverty}
          size="small"
          label="Aliq. Fundo Comb. Pobreza ST"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsStAliquotPoverty,
    setProductIcmsStAliquotPoverty,
    visualizationOnly,
  ]);

  const valorIcmsFundoCombPobrezaSt = useCallback(() => {
    return (
      <Grid item lg={6} sm={12}>
        <TextField
          key="valorIcmsFundoCombPobrezaSt"
          value={productIcmsStValuePoverty}
          setValue={setProductIcmsStValuePoverty}
          size="small"
          label="Valor ICMS Fundo Comb. Pobreza ST"
          mask="decimal"
          disabled={visualizationOnly}
        />
      </Grid>
    );
  }, [
    productIcmsStValuePoverty,
    setProductIcmsStValuePoverty,
    visualizationOnly,
  ]);

  const fieldList = useMemo(
    () => ({
      modalidadeBcIcms: {
        jsx: modalidadeBcIcms(),
        setter: setProductIcmsModality,
        defaultValue: null,
      },
      bcIcms: {
        jsx: bcIcms(),
        setter: setProductIcmsValueBc,
        defaultValue: "0,00",
      },
      reducaoBcIcms: {
        jsx: reducaoBcIcms(),
        setter: setProductIcmsPercentReduct,
        defaultValue: "0,0000",
      },
      aliquotaIcms: {
        jsx: aliquotaIcms(),
        setter: setProductIcmsAliquot,
        defaultValue: "0,00",
      },
      valorIcms: {
        jsx: valorIcms(),
        setter: setProductIcmsValue,
        defaultValue: "0,00",
      },
      aliquotaCredIcms: {
        jsx: aliquotaCredIcms(),
        setter: setProductIcmsAliquotCredit,
        defaultValue: "0,00",
      },
      credAproveitadoIcms: {
        jsx: credAproveitadoIcms(),
        setter: setProductIcmsCreditAprove,
        defaultValue: "0,00",
      },
      bcRetidoIcmsSt: {
        jsx: bcRetidoIcmsSt(),
        setter: setProductIcmsStValueBcRet,
        defaultValue: "0,00",
      },
      valorRetidoIcmsSt: {
        jsx: valorRetidoIcmsSt(),
        setter: setProductIcmsStValueRet,
        defaultValue: "0,00",
      },
      modalidadeBcIcmsSt: {
        jsx: modalidadeBcIcmsSt(),
        setter: setProductIcmsStModality,
        defaultValue: null,
      },
      mvaBcIcmsSt: {
        jsx: mvaBcIcmsSt(),
        setter: setProductIcmsStPercentAdd,
        defaultValue: "0,00",
      },
      reducaoBcIcmsSt: {
        jsx: reducaoBcIcmsSt(),
        setter: setProductIcmsStPercentReductBc,
        defaultValue: "0,00",
      },
      bcIcmsSt: {
        jsx: bcIcmsSt(),
        setter: setProductIcmsStValueBc,
        defaultValue: "0,00",
      },
      aliquotaIcmsSt: {
        jsx: aliquotaIcmsSt(),
        setter: setProductIcmsStAliquot,
        defaultValue: "0,00",
      },
      valorIcmsSt: {
        jsx: valorIcmsSt(),
        setter: setProductIcmsStValue,
        defaultValue: "0,00",
      },
      bcFcpRetidoIcmsSt: {
        jsx: bcFcpRetidoIcmsSt(),
        setter: setProductIcmsStBcPovertyRet,
        defaultValue: "0,00",
      },
      aliquotaFcpRetidoIcmsSt: {
        jsx: aliquotaFcpRetidoIcmsSt(),
        setter: setProductIcmsStAliqPovertyRet,
        defaultValue: "0,00",
      },
      valorFcpRetidoIcmsSt: {
        jsx: valorFcpRetidoIcmsSt(),
        setter: setProductIcmsStValuePovertyRet,
        defaultValue: "0,00",
      },
      aliquotaConsumidorIcms: {
        jsx: aliquotaConsumidorIcms(),
        setter: setProductIcmsAliquotSupCons,
        defaultValue: "0,00",
      },
      valorProprioIcms: {
        jsx: valorProprioIcms(),
        setter: setProductIcmsOwnSubValue,
        defaultValue: "0,00",
      },
      aliquotaIcmsInterestadual: {
        jsx: aliquotaIcmsInterestadual(),
        setter: setProductIcmsAliquotInterstate,
        defaultValue: "0,00",
      },
      aliquotaIcmsInternaDest: {
        jsx: aliquotaIcmsInternaDest(),
        setter: setProductIcmsAliquotInternal,
        defaultValue: "0,00",
      },
      aliquotaFundoCombPobreza: {
        jsx: aliquotaFundoCombPobreza(),
        setter: setProductIcmsAliquotPoverty,
        defaultValue: "0,00",
      },
      bcFundoCombPobreza: {
        jsx: bcFundoCombPobreza(),
        setter: setProductIcmsBcPoverty,
        defaultValue: "0,00",
      },
      valorIcmsFundoCombPobreza: {
        jsx: valorIcmsFundoCombPobreza(),
        setter: setProductIcmsValuePoverty,
        defaultValue: "0,00",
      },
      cBenef: {
        jsx: cBenef(),
        setter: setProductIcmsCbenef,
        defaultValue: "",
      },
      icmsDesonerado: {
        jsx: icmsDesonerado(),
        setter: setProductIcmsValueDes,
        defaultValue: "0,00",
      },
      motivoDesoneracao: {
        jsx: motivoDesoneracao(),
        setter: setProductImcsMotivoDes,
        defaultValue: "",
      },
      bcFundoCombPobrezaSt: {
        jsx: bcFundoCombPobrezaSt(),
        setter: setProductIcmsStBcPoverty,
        defaultValue: "0,00",
      },
      aliquotaFundoCombPobrezaSt: {
        jsx: aliquotaFundoCombPobrezaSt(),
        setter: setProductIcmsStAliquotPoverty,
        defaultValue: "0,00",
      },
      valorIcmsFundoCombPobrezaSt: {
        jsx: valorIcmsFundoCombPobrezaSt(),
        setter: setProductIcmsStValuePoverty,
        defaultValue: "0,00",
      },
    }),
    [
      modalidadeBcIcms,
      bcIcms,
      reducaoBcIcms,
      aliquotaIcms,
      valorIcms,
      aliquotaCredIcms,
      credAproveitadoIcms,
      bcRetidoIcmsSt,
      valorRetidoIcmsSt,
      modalidadeBcIcmsSt,
      mvaBcIcmsSt,
      reducaoBcIcmsSt,
      bcIcmsSt,
      aliquotaIcmsSt,
      valorIcmsSt,
      bcFcpRetidoIcmsSt,
      aliquotaFcpRetidoIcmsSt,
      valorFcpRetidoIcmsSt,
      aliquotaConsumidorIcms,
      valorProprioIcms,
      aliquotaIcmsInterestadual,
      aliquotaIcmsInternaDest,
      aliquotaFundoCombPobreza,
      bcFundoCombPobreza,
      valorIcmsFundoCombPobreza,
      cBenef,
      icmsDesonerado,
      motivoDesoneracao,
      bcFundoCombPobrezaSt,
      aliquotaFundoCombPobrezaSt,
      valorIcmsFundoCombPobrezaSt,
      setProductIcmsModality,
      setProductIcmsValueBc,
      setProductIcmsPercentReduct,
      setProductIcmsAliquot,
      setProductIcmsValue,
      setProductIcmsAliquotCredit,
      setProductIcmsCreditAprove,
      setProductIcmsStValueBcRet,
      setProductIcmsStValueRet,
      setProductIcmsStModality,
      setProductIcmsStPercentAdd,
      setProductIcmsStPercentReductBc,
      setProductIcmsStValueBc,
      setProductIcmsStAliquot,
      setProductIcmsStValue,
      setProductIcmsStBcPovertyRet,
      setProductIcmsStAliqPovertyRet,
      setProductIcmsStValuePovertyRet,
      setProductIcmsAliquotSupCons,
      setProductIcmsOwnSubValue,
      setProductIcmsAliquotInterstate,
      setProductIcmsAliquotInternal,
      setProductIcmsAliquotPoverty,
      setProductIcmsBcPoverty,
      setProductIcmsValuePoverty,
      setProductIcmsCbenef,
      setProductIcmsValueDes,
      setProductImcsMotivoDes,
      setProductIcmsStBcPoverty,
      setProductIcmsStAliquotPoverty,
      setProductIcmsStValuePoverty,
    ]
  );

  useEffect(() => {
    if (lastTaxation !== rulesTaxation) {
      for (const [key, component] of Object.entries(fieldList)) {
        if (
          ![
            ...(rulesTaxation.ICMS || []),
            ...(rulesTaxation.ST || []),
          ].includes(key)
        )
          component.setter(component.defaultValue);
      }
      setLastTaxation(rulesTaxation);
    }
  }, [fieldList, lastTaxation, rulesTaxation]);

  const jsxFieldsTaxation = useMemo(
    () => rulesTaxation[type]?.map((fieldName) => fieldList[fieldName].jsx),
    [fieldList, rulesTaxation, type]
  );

  return <>{jsxFieldsTaxation}</>;
};

export default memo(RenderTaxationFields);
